import React from 'react';
import Input from '../../../Components/Input';
import DimensionSelector from '../DimensionSelector';
import TypographySelector from '../TypographySelector';
import PositionSelector from '../PositionSelector';
import { BuilderActionType, BuilderContext } from '../state';
import VendexElement, { VendexInputMeta } from '../../../Model/VendexElement';
import Select from '../../../Components/Select';
import { BuilderField, BuilderFieldGrid } from '../BuilderFields';

type Props = {
    element: VendexElement;
};

function InputDetail({ element }: Props) {
    const data = element.metaData as VendexInputMeta;

    const { dispatch } = React.useContext(BuilderContext);

    const handleChange = (value: VendexElement) => {
        dispatch({
            type: BuilderActionType.UPDATE_ELEMENT,
            payload: value,
        });
    };

    const handleDataChange = (name: string, value: string | boolean) => {
        handleChange({
            ...element,
            metaData: { ...data, [name]: value },
        });
    };

    return (
        <>
            <BuilderFieldGrid>
                <BuilderField label="Name">
                    <Input
                        onChange={(e) => {
                            handleDataChange('name', e.target.value);
                        }}
                        value={data.name}
                    />
                </BuilderField>
                <BuilderField label="Type">
                    <Select
                        onChange={(e) => {
                            handleDataChange('type', e.target.value);
                        }}
                        value={data.type}
                    >
                        <option value="text">text</option>
                        <option value="number">number</option>
                        <option value="date">date</option>
                        <option value="password">password</option>
                    </Select>
                </BuilderField>
                <BuilderField label="Placeholder">
                    <Input
                        onChange={(e) => {
                            handleDataChange('placeholder', e.target.value);
                        }}
                        value={data.placeholder ? data.placeholder : ''}
                    />
                </BuilderField>
                <BuilderField label="Auto focus">
                    <Select
                        value={data.autoFocus ? 'Yes' : 'No'}
                        onChange={(e) =>
                            handleDataChange(
                                'autoFocus',
                                e.target.value === 'Yes',
                            )
                        }
                    >
                        <option value="No">No</option>
                        <option value="Yes">Yes</option>
                    </Select>
                </BuilderField>
            </BuilderFieldGrid>
            <TypographySelector
                selector={`#${element.id}`}
                hasAlignment={false}
            />
            <PositionSelector selector={`#${element.id}`} />
            <DimensionSelector selector={`#${element.id}`} />
        </>
    );
}

export default InputDetail;
